import React from 'react';

import { useCustomTranslation } from '../../../../hooks/custom-translation';
import { AgeGroupByGenderProps } from '../../../../services/descriptiveAnalysisReport/descriptiveAnalysis';
import { H5 } from '../../../../styles/fonts';
import AgeGroupByGenderBar from '../SocioDemographicTab/AgeGroupByGenderBar';

import { Content02, Row011, Data012 } from './styles';

interface AgeGroupByGenderTabProps {
  ageGroupsByGender: AgeGroupByGenderProps[];
}

const AgeGroupByGenderTab = ({
  ageGroupsByGender,
}: AgeGroupByGenderTabProps) => {
  const { tModalDescriptiveAnalysis } = useCustomTranslation(
    'modalDescriptiveAnalysis',
  );

  return (
    <Content02>
      <Row011>
        <Data012>
          <H5 weight="medium">
            {tModalDescriptiveAnalysis('age_group_by_gender')}
          </H5>
          <AgeGroupByGenderBar data={ageGroupsByGender || []} />
        </Data012>
      </Row011>
    </Content02>
  );
};

export default AgeGroupByGenderTab;
